"use client";

import React from "react";
// import noDataAnimation from './animations/no-data.json'; // Replace with your downloaded Lottie animation
// import { Player } from '@lottiefiles/react-lottie-player'

// import Lottie from "lottie-react";

import dynamic from "next/dynamic";
import { Button } from "../ui/button";

const LottiePlayer = dynamic(() => import("lottie-react").then((mod) => mod), {
  ssr: false,
});

type NoDataProps = {
  jsonPath: any;
  message?: string;
  actionLabel?: string;
  onAction?: () => void;
};

const NoData: React.FC<NoDataProps> = ({
  jsonPath,
  message = "No data found!",
  actionLabel = "Add New Item",
  onAction,
}) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        // height: '100vh',
        textAlign: "center",
      }}
    >
      {/* Lottie Animation */}
      <div style={{ width: "300px", height: "300px" }}>
        <LottiePlayer
          // autoplay
          // loop
          // src={jsonPath}
          // style={{ height: '100%', width: '100%' }}\
          animationData={jsonPath}
          loop
        />
      </div>

      {/* Message */}
      <h2 style={{ marginTop: "20px", fontSize: "24px", color: "#333" }}>
        {message}
      </h2>

      {/* Action Button */}
      {onAction && (
        <Button onClick={onAction} variant={"destructive"} style={{}}>
          {actionLabel}
        </Button>
      )}
    </div>
  );
};

export default NoData;
